import { TextIcon } from "../../../CommonUI/TextIcon";
import React from "react";
import { BaseJSONXMLElementEditor } from "./BaseJSONXMLElementEditor";
import { JSONXMLBooleanElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLBooleanElement";

export class JSONXMLBooleanEditor extends BaseJSONXMLElementEditor<JSONXMLBooleanElement> {
    getIcon(): JSX.Element {
        return <TextIcon name={"t/f"} />;
    }
}
